export default "__VITE_ASSET__C$EMdDzJ__"